import styled from 'styled-components'

import { generateMaxHeightBreakPoint } from '@constants'

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: space-between;
  transition: max-height 200ms;
  padding: 0 12px;
  min-height: ${({ theme }) => theme.appBarHeight}px;

  ${generateMaxHeightBreakPoint('medium')} {
    min-height: ${({ theme }) => theme.appBarHeightMedium}px;
  }
`
